import { render, staticRenderFns } from "./UploadFormModal.vue?vue&type=template&id=f71b777e&lang=true&"
import script from "./UploadFormModal.vue?vue&type=script&lang=js&"
export * from "./UploadFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports